// Modern indigo-slate design system
export const BRAND = "#4F46E5";          // Indigo-600 — primary actions
export const BRAND_DARK = "#3730A3";     // Indigo-800 — hover / pressed
export const BRAND_SOFT = "#EEF2FF";     // Indigo-50 — light tints
export const BRAND_TINT = "#F5F7FF";     // Lighter indigo wash
export const SIDEBAR_BG = "#1E1B4B";     // Indigo-950 — deep, elegant
export const SIDEBAR_GRAD = "linear-gradient(180deg,#1E1B4B 0%,#312E81 100%)";
export const PROG_GRAD = "linear-gradient(90deg,#4F46E5,#06B6D4)";
export const HERO_GRAD = "linear-gradient(135deg,#1E1B4B 0%,#3730A3 40%,#4F46E5 100%)";
export const CARD_GRADS = [
  "linear-gradient(135deg,#4F46E5,#818CF8)",
  "linear-gradient(135deg,#0EA5E9,#06B6D4)",
  "linear-gradient(135deg,#EC4899,#F472B6)",
  "linear-gradient(135deg,#F59E0B,#FBBF24)",
  "linear-gradient(135deg,#10B981,#34D399)",
  "linear-gradient(135deg,#8B5CF6,#A78BFA)",
];
export const ACCENTS = [
  { bg: "#EEF2FF", fg: "#4F46E5", ring: "#C7D2FE" },  // indigo
  { bg: "#EEF2FF", fg: "#6366F1", ring: "#C7D2FE" },  // indigo-lighter
  { bg: "#EEF2FF", fg: "#4338CA", ring: "#A5B4FC" },  // indigo-deeper
  { bg: "#EEF2FF", fg: "#818CF8", ring: "#C7D2FE" },  // indigo-soft
  { bg: "#F0F9FF", fg: "#0284C7", ring: "#BAE6FD" },  // sky accent
  { bg: "#F5F3FF", fg: "#7C3AED", ring: "#DDD6FE" },  // violet accent
];
export const BAR_COLORS = ["#4F46E5", "#7C3AED", "#0EA5E9", "#6366F1", "#8B5CF6", "#0284C7", "#4338CA", "#818CF8", "#38BDF8", "#A78BFA"];
